import React, { useEffect, useRef, useState } from 'react';

const FilterDropdown = ({ value, onChange, options, placeholder }) => {
  const [isOpen, setIsOpen] = useState(false);
  const rootRef = useRef(null);
  const dropdownOptions = [{ value: '', label: placeholder }, ...options];
  const selectedOption = dropdownOptions.find(option => option.value === value) || dropdownOptions[0];

  useEffect(() => {
    if (!isOpen) return undefined;

    const handleClickOutside = (event) => {
      if (rootRef.current && !rootRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    const handleKeyDown = (event) => {
      if (event.key === 'Escape') setIsOpen(false);
    };

    document.addEventListener('mousedown', handleClickOutside);
    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [isOpen]);

  return (
    <div ref={rootRef} className={`filter-dropdown${isOpen ? ' open' : ''}`}>
      <button
        type="button"
        className="filter-dropdown-trigger"
        aria-haspopup="listbox"
        aria-expanded={isOpen}
        onClick={() => setIsOpen(prev => !prev)}
      >
        <span className="filter-dropdown-value">{selectedOption.label}</span>
        <span className="filter-dropdown-chevron" aria-hidden="true" />
      </button>
      {isOpen && (
        <div className="filter-dropdown-menu" role="listbox">
          {dropdownOptions.map(option => (
            <button
              key={option.value || 'all'}
              type="button"
              role="option"
              aria-selected={option.value === value}
              className={`filter-dropdown-option${option.value === value ? ' selected' : ''}`}
              onClick={() => {
                onChange(option.value);
                setIsOpen(false);
              }}
            >
              {option.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default FilterDropdown;
